import styled from 'styled-components';

export const LinkInputRoot = styled.div`
  margin-top: 32px;
`;
